"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPredictions = void 0;

var _tslib = require("tslib");

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var fetchPredictions = function fetchPredictions(request) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _axios["default"].get(request).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchPredictions = fetchPredictions;